import { render } from "./SectionPlaceholder.vue?vue&type=template&id=df56b0c6&scoped=true"
import script from "./SectionPlaceholder.vue?vue&type=script&lang=js"
export * from "./SectionPlaceholder.vue?vue&type=script&lang=js"

import "./SectionPlaceholder.vue?vue&type=style&index=0&id=df56b0c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df56b0c6"]])

export default __exports__